/* eslint-disable no-unused-vars */

// import { store } from '@redux/store';
import moment from 'moment';
import _ from 'lodash';

import EquipmentSelector from './equipment.selector';

import TasksSelector from './tasks/tasks.selector';
import { getTaskAssignedUserTags } from './tasks/helper';
import { getDataPoints, getMoreInfoDataPoints } from '../pages/settings/helper';
import CheckSelector from './checks/check.selector';
import InspectionSelector from './inspection/inspection.selector';

const StructureSelector = {
  getStructuresWithWO: async ({
    id = '',
    ids = [],
    formWrapper = false,
    store,
    createSiteDataPoints = false
  }) => {
    const { tasks, auth, jurisdictionNumbers, settings, picklists, structure, cache } = store;

    const { sites: cacheSites = [], sitesMap = {} } = cache;

    const userId = auth.userId || '';
    const [res1, structureEquipmentMap] = !formWrapper
      ? await Promise.all([
          await StructureSelector.getAllWorkOrdersAndInspections({ store, userId }),
          await StructureSelector.getStructureEquipmentMap({ store, userId })
        ])
      : [[], []];

    const allWOTasks = res1?.allTasksLst || [];
    const onDemandRecordList = res1?.onDemandRecordList || [];

    return new Promise((resolve) => {
      const { workOrderUsersMap, workOrderUsersGroupsMap } = tasks;

      const { structureMobile } = structure;
      const { jurisdictionNumbersMap = {} } = jurisdictionNumbers;

      const structureDisplayFields = settings.settings?.['structureDisplayFields'] || '';
      const structureHiddenDisplayFields = settings.hiddenDataPointsForAssets?.structure || '';

      const { picklistsMap = {} } = picklists;

      const responsibleUsersMap = {
        ...(workOrderUsersMap || {}),
        ...(workOrderUsersGroupsMap || {})
      };

      const structures = id
        ? structureMobile?.filter((x) => x.structureId == id)
        : ids?.length
        ? structureMobile?.filter((x) => [...ids]?.includes(x?.structureId))
        : structureMobile;
      let prepareStructures = [];

      structures.map(async (structure) => {
        const equipments = structureEquipmentMap[structure.structureId] || [];

        const allEditEquipmentAssets =
          equipments?.length > 0
            ? await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({
                store,
                equipmentIds: equipments
              })
            : [];

        let allTasksForStructure = allWOTasks.filter(
          (t) =>
            t.structureId === structure.structureId ||
            t?.relatedAssetId === structure?.structureId ||
            t?.primaryAssetId === structure?.structureId ||
            t?.structures?.includes(structure?.structureId) ||
            equipments?.includes(t?.equipmentId) ||
            equipments?.includes(t?.relatedAssetId) ||
            equipments?.includes(t?.primaryAssetId) ||
            t?.equipments?.some((y) => equipments?.includes(y))
        );

        let allOnDemandRecordCount = onDemandRecordList.filter(
          (t) =>
            t.structureId === structure.structureId ||
            t?.relatedAssetId === structure?.structureId ||
            t?.primaryAssetId === structure?.structureId ||
            t?.structures?.includes(structure?.structureId) ||
            equipments?.includes(t?.equipmentId) ||
            equipments?.includes(t?.relatedAssetId) ||
            equipments?.includes(t?.primaryAssetId) ||
            t?.equipments?.some((y) => equipments?.includes(y))
        );

        allTasksForStructure = allTasksForStructure.map((tas) => {
          const { responsibleUsers = [], responsibleUserGroups = [] } = tas;
          const customAssignedTaskValue = getTaskAssignedUserTags({
            responsibleUsers,
            responsibleUserGroups,
            workOrderUsersGroupsMap,
            userId,
            responsibleUsersMap
          });
          return {
            customAssignedTaskValue,
            ...tas
          };
        });

        const allDoneTasks = allTasksForStructure.filter((task) => task?.status === 'Synced');
        const allotDoneTasks = allTasksForStructure.filter((task) => task?.status !== 'Synced');

        const today = moment().format('YYYY-MM-DD');
        const isOverDue = allotDoneTasks.find((task) =>
          task.dueDate ? moment(task.dueDate).isBefore(today) : false
        );

        const { jurisdictionNumber } = jurisdictionNumbersMap[structure?.structure] || {};

        const dataPoints = getDataPoints(
          { ...structure, subtype: structure?.structureType, jurisdictionNumber },
          structureDisplayFields,
          'structure',
          picklistsMap
        );

        const dataPointsForSearch = structureHiddenDisplayFields
          ? getDataPoints(
              { ...structure, subtype: structure?.structureType, jurisdictionNumber },
              structureHiddenDisplayFields,
              'structure',
              picklistsMap
            )
          : [];

        let dataPointsForSite = [],
          siteDataPointsForSearch = [];

        if (createSiteDataPoints) {
          const site = structure?.siteId ? cacheSites[sitesMap[structure.siteId]] || {} : {};

          if (site) {
            const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';
            const siteDisplayFields = settings.settings?.siteDisplayFields;

            dataPointsForSite = getDataPoints(
              { ...site, type: site.siteType },
              siteDisplayFields,
              'site',
              picklistsMap
            );

            siteDataPointsForSearch = siteHiddenDisplayFields
              ? getDataPoints(
                  { ...site, type: site?.siteType },
                  siteHiddenDisplayFields,
                  'site',
                  picklistsMap
                )
              : [];
          }
        }

        prepareStructures.push({
          ...structure,
          status: !formWrapper ? structure?.status : null,
          equipments,
          allDoneTasks,
          isOverDue,
          allTasksForStructure,
          allotDoneTasks,
          dataPoints,
          dataPointsForSearch,
          soonestDueDate: _.min(
            allotDoneTasks.map((t) => t?.due || t?.dueDate).map((date) => new Date(date))
          ),
          allOnDemandRecordCount: allOnDemandRecordCount?.length || 0,

          dataPointsForSite,
          siteDataPointsForSearch,
          allEditEquipmentAssets
        });
      });
      resolve(prepareStructures);
    });
  },

  getStructureEquipmentMap: async ({ structureId = null, store, userId }) => {
    const equipments = await EquipmentSelector.getEquipmentsWithAllTasks({
      structureId,
      store,
      userId
    });

    return equipments.reduce((acc, { structureId, equipmentId }) => {
      if (structureId) {
        if (!acc[structureId]) {
          acc[structureId] = [equipmentId];
        } else {
          acc[structureId].push(equipmentId);
        }
      }
      return acc;
    }, {});
  },

  getStructureWithEquipment: async ({
    structureId = '',
    store,
    userId,
    getWorkRequestData = false
  }) => {
    const {
      cache,
      picklists,
      jurisdictionNumbers,
      settings,
      structure,
      tasks: storeTasks,
      checks
    } = store;
    const {
      equipmentsMap = {},
      equipmentsLoading: sitesLoading,
      equipments: cacheEquipments = []
    } = cache;
    let cacheTasksLists = storeTasks?.tasksList;
    let checksList = checks?.checksList;

    const { structure: cacheStructures, structuresMap } = structure;

    const structureDisplayFields = settings?.settings?.['structureDisplayFields'] || '';
    const equipmentDisplayFields = settings?.settings?.['equipmentDisplayFields'] || '';
    const { jurisdictionNumbersMap = {} } = jurisdictionNumbers;
    const { picklistsMap = {} } = picklists;

    const [res1, structureEquipmentMap] = await Promise.all([
      await StructureSelector.getAllWorkOrdersAndInspections({
        structureId,
        cacheEquipments,
        store,
        userId,
        getWorkRequestData
      }),
      await StructureSelector.getStructureEquipmentMap({ structureId, store, userId })
    ]);

    const tasks = res1?.allTasksLst || [];
    const newWorkRequestList = res1?.newWorkRequestList || [];
    const onDemandRecordList = res1?.onDemandRecordList || [];
    const newWorkOrderList = res1?.newWorkOrderList || [];

    const equipments =
      (structureEquipmentMap[structureId] || []).filter(
        (id) => cacheEquipments[equipmentsMap[id]]
      ) || [];

    const allEditEquipmentAssets =
      equipments?.length > 0
        ? await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({
            store,
            equipmentIds: equipments
          })
        : [];

    const parentStructure = cacheStructures[structuresMap[structureId]] || {};

    const allDoneTasks = tasks?.filter((task) => task?.status === 'Synced');
    const allNotDoneTasks = tasks?.filter((task) => task?.status !== 'Synced');

    const allWorkOrders = tasks?.filter((x) => x.type === 'Work Order');
    const allDoneWorkOrders = allDoneTasks?.filter((x) => x.type === 'Work Order');
    const allNotDoneWorkOrders = allNotDoneTasks.filter((task) => task?.status !== 'Synced');

    const allChecks = tasks?.filter((x) => x.type === 'Check');
    const allDoneChecks = allDoneTasks?.filter((x) => x.type === 'Check');
    const allNotDoneChecks = allNotDoneTasks.filter((x) => x.type === 'Check');

    const allInspections = tasks?.filter((x) => x.type === 'Inspection');
    const allDoneInspections = allDoneTasks?.filter((x) => x.type === 'Inspection');
    const allNotDoneInspections = allNotDoneTasks.filter((x) => x.type === 'Inspection');

    const today = moment().format('YYYY-MM-DD');

    const isOverDue = allNotDoneTasks.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );

    const isInspectionOverDue = allNotDoneInspections.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );

    const isWorkOrderOverDue = allNotDoneWorkOrders.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );

    const isCheckOverDue = allNotDoneChecks.find((task) =>
      task.nextDue ? moment(task.nextDue).isBefore(today) : false
    );

    const { name, structureType, siteId, link } = parentStructure;
    const status = picklistsMap[parentStructure.status]?.value;
    const type = picklistsMap[structureType]?.value;
    const data = { ...parentStructure, type: structureType };

    const dataPoints = getDataPoints(
      { ...data },
      structureDisplayFields,
      'structure',
      picklistsMap
    );

    const dataPointsMap = dataPoints.reduce((acc, curr) => {
      acc[curr.Id] = curr;
      return acc;
    }, {});
    dataPointsMap['Status'] = { value: status, title: 'Status' };

    const MoreInfoDataPoints = getMoreInfoDataPoints({ ...data }, 'structure', picklistsMap);
    const MoreInfoDataPointsMap = MoreInfoDataPoints.reduce((acc, curr) => {
      acc[curr.Id] = curr;
      return acc;
    }, {});
    MoreInfoDataPointsMap['Status'] = { value: status, title: 'Status' };
    MoreInfoDataPointsMap['Name'] = { value: name, title: 'Name' };
    MoreInfoDataPointsMap['Type'] = { value: type, title: 'Type' };

    const equipmentAllFieldData = await EquipmentSelector.getEquipmentsWithAllTasks({
      store,
      equipmentIds: equipments,
      onlyTaskCount: true
    });
    // equipments?.map((equipment) => {
    //   const equipmentsTasks = tasks?.filter((t) => {
    //     return (
    //       t?.equipmentId === equipment ||
    //       t?.relatedAssetId === equipment ||
    //       t?.equipments?.includes(equipment)
    //     );
    //   });

    //   const a = onDemandRecordList?.filter((t) => {
    //     return (
    //       t?.equipmentId === equipment ||
    //       t?.relatedAssetId === equipment ||
    //       t?.equipments?.includes(equipment)
    //     );
    //   });

    //   const allDoneTasks = equipmentsTasks?.filter((task) => task?.status === 'Synced');
    //   const allNotDoneTasks = equipmentsTasks?.filter((task) => task?.status !== 'Synced');
    //   const today = moment().format('YYYY-MM-DD');
    //   const isOverDue = allNotDoneTasks?.find((task) =>
    //     task?.dueDate ? moment(task?.dueDate).isBefore(today) : false
    //   );

    //   const equData = cacheEquipments[equipmentsMap[equipment]] || {};
    //   const { jurisdictionNumber } = jurisdictionNumbersMap[equipment] || {};
    //   const dataPoints = getDataPoints(
    //     { ...equData, subtype: equData?.equipmentSubType, jurisdictionNumber },
    //     equipmentDisplayFields,
    //     'equipment',
    //     picklistsMap
    //   );

    //   return {
    //     ...equData,
    //     allDoneTasks,
    //     isOverDue,

    //     allTasksForSite: equipmentsTasks,
    //     allotDoneTasks: allNotDoneTasks,
    //     dataPoints,
    //     allOnDemandRecordCount: a?.length || 0
    //   };
    // });

    let allOnDemandRecordCount = onDemandRecordList.filter(
      (t) =>
        t.structureId === structureId ||
        t?.relatedAssetId === structureId ||
        t?.primaryAssetId === structureId ||
        t?.structures?.includes(structureId) ||
        equipments?.includes(t?.equipmentId) ||
        equipments?.includes(t?.relatedAssetId) ||
        equipments?.includes(t?.primaryAssetId) ||
        t?.equipments?.some((y) => equipments?.includes(y))
    );

    const tasks1 = _.size(_.flattenDeep(tasks)) > 0 ? _.flattenDeep(tasks) : [];

    return {
      siteId,
      name,
      allInspections,
      allDoneInspections,
      isInspectionOverDue,
      tasks: tasks1,
      allDoneTasks: _.size(_.flattenDeep(allDoneTasks)) > 0 ? _.flattenDeep(allDoneTasks) : [],
      isOverDue,
      allWorkOrders: _.size(_.flattenDeep(allWorkOrders)) > 0 ? _.flattenDeep(allWorkOrders) : [],
      allDoneWorkOrders:
        _.size(_.flattenDeep(allDoneWorkOrders)) > 0 ? _.flattenDeep(allDoneWorkOrders) : [],
      allChecks: _.size(_.flattenDeep(allChecks)) > 0 ? _.flattenDeep(allChecks) : [],
      allDoneChecks: _.size(_.flattenDeep(allDoneChecks)) > 0 ? _.flattenDeep(allDoneChecks) : [],
      isWorkOrderOverDue,
      isCheckOverDue,
      status,
      equipments,
      structuresMap,
      equipmentsMap,
      dataPoints,
      type,
      // siteInfo,
      dataPointsMap,
      MoreInfoDataPointsMap,
      equipmentAllFieldData,
      link,
      newWorkRequestList,
      allOnDemandRecordCount: allOnDemandRecordCount?.length || 0,
      newWorkOrderList,
      newChecksList: [],
      allEditEquipmentAssets
    };
  },

  getAllWorkOrdersAndInspections: async ({
    templatesIds = null,
    structureId = null,
    cacheEquipments = [],
    store,
    userId,
    getWorkRequestData = false
  }) => {
    const { checks: storeChecks } = store;
    const { checksList = [] } = storeChecks;

    const equipmentIds = structureId
      ? cacheEquipments?.filter((x) => x?.structureId === structureId)?.map((x) => x?.equipmentId)
      : [];

    const tasks = await TasksSelector.getTasks({
      structureId,
      equipmentIds,
      store,
      userId
    });

    const inspections =
      structureId && equipmentIds?.length === 0
        ? []
        : await InspectionSelector.getInspections({
            equipmentIds,
            store
          });

    const checks = await CheckSelector.getAllChecks({ store, structureId, equipmentIds });

    const allAssignedWorkOrders = _.isEmpty(templatesIds)
      ? tasks?.filter((task) =>
          task.newWorkOrder && task?.status !== 'To do'
            ? task?.responsible?.[0]?.woUserRequestId === userId
              ? true
              : false
            : task?.status === 'Synced'
            ? !task?.isNew
              ? true
              : false
            : !task.newWorkRequest
        )
      : tasks?.filter((task) =>
          task.newWorkOrder && task?.status !== 'To do'
            ? task?.responsible?.[0]?.woUserRequestId === userId
              ? true
              : false
            : task?.status === 'Synced'
            ? !task?.isNew
              ? true
              : false
            : !task.newWorkRequest && templatesIds?.includes(task?.rtNumber)
        );

    const allAssignedChecks = checks;

    const newWorkRequestList = _.isEmpty(templatesIds)
      ? tasks?.filter((task) => task.newWorkRequest || task?.entityType === 'WorkRequest')
      : tasks?.filter(
          (task) =>
            (task.newWorkRequest || task?.entityType === 'WorkRequest') &&
            templatesIds?.includes(task?.rtNumber)
        );

    const newWorkOrderList = _.isEmpty(templatesIds)
      ? tasks?.filter((task) =>
          (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
          task?.responsible?.[0]?.woUserRequestId !== userId &&
          task?.status !== 'To do' &&
          task?.status !== 'Synced'
            ? true
            : task?.status === 'Synced' && task?.isNew && task?.entityType !== 'WorkRequest'
            ? true
            : false
        )
      : tasks?.filter((task) =>
          (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
          task?.responsible?.[0]?.woUserRequestId !== userId &&
          task?.status !== 'To do' &&
          task?.status !== 'Synced'
            ? true
            : task?.status === 'Synced' && task?.isNew && task?.entityType !== 'WorkRequest'
            ? true
            : templatesIds?.includes(task?.rtNumber)
        );

    let onDemandRecordList = [];

    onDemandRecordList = [...newWorkRequestList, ...newWorkOrderList];

    return {
      allTasksLst: [...allAssignedWorkOrders, ...allAssignedChecks, ...inspections],
      newWorkRequestList,
      newWorkOrderList,
      onDemandRecordList
    };
  }
};

export default StructureSelector;
